import { createModule } from '../../createModule';
export const createSalesAPI = createModule(({ http }) => {
    return {
        getInstruments: async () => {
            const res = await http.get(`/v2/funds/map/shareclasses/launched`);
            return res;
        },
        getYearlyPerformance: async (params) => {
            const res = await http.get(`/v2/sales/get_performance_yearly`, { params });
            return res;
        },
        getMonthlyPerformance: async (params) => {
            const res = await http.get(`/v2/sales/get_performance_monthly`, { params });
            return res;
        },
        getPerformanceOffset: async (params) => {
            const res = await http.get(`/v2/sales/get_performance_offset`, { params });
            return res;
        },
        getOCFSchedule: async (params) => {
            const res = await http.get(`/v2/funds/ocf`, {
                params,
            });
            return res;
        },
        getShareclassDetails: async (params) => {
            const res = await http.get(`/v2/sales/get_shareclass_data`, {
                params,
            });
            return res;
        },
        sendEmail: async (body) => {
            const res = await http.post(`/v2/sales/send_report`, { body: body });
            return res;
        },
    };
});
